import React from "react";
import { Link, useNavigate } from "react-router-dom";
import NotFoundImg from "../assets/images/brands/406.png";

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="bg-light min-vh-100 d-flex align-items-center justify-content-center py-5 px-3">
      <div
        className="card box-shadow-datatables shadow-border-2 mt-4 w-100"
        style={{ maxWidth: 900, borderRadius: 16 }}
      >
        <div className="card-body p-4 p-md-5 text-center">
          {/* IMAGE */}
          <div className="d-flex justify-content-center">
            <img
              src={NotFoundImg}
              alt="404 Page Not Found"
              className="img-fluid"
              style={{ maxWidth: 650 }}
              draggable={false}
            />
          </div>

          {/* TEXT */}
          <h2 className="mt-4 fw-bold text-dark">Page Not Found</h2>
          <p className="text-muted mb-4">
            Oops! The page you are looking for could not be found. It may have
            been moved, deleted, or the URL may be incorrect.
          </p>

          {/* BUTTONS */}
          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn btn-outline-secondary px-4 py-2"
              style={{ borderRadius: 10 }}
            >
              Go Back
            </button>

            <Link
              to="/"
              className="btn btn-primary px-4 py-2"
              style={{ borderRadius: 10 }}
            >
              Go Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
